module.exports = __webpack_public_path__ + "static/media/galerija_2018 (2).14010eb7.jpg";